import { useQuery, UseQueryResult } from "react-query";
import { ClusterAnalyticsSummary } from "../../pages/Clusters/Analytics/ClusterStatistics";
import { useWorkspaceContextSlug } from "../../utils/hooks";
import { getClusterAnalyticsSummary } from "./fetch";
import { TimeRange } from "../../pages/Clusters/types";

export const useClusterAnalyticsSummary = (
  clusterId?: number,
  defaultTimeRange?: TimeRange,
): UseQueryResult<ClusterAnalyticsSummary> => {
  const accountSlug = useWorkspaceContextSlug();
  return useQuery(
    ["cluster-analytics-summary", accountSlug, clusterId, defaultTimeRange],
    () => {
      return getClusterAnalyticsSummary(accountSlug, clusterId!);
    },
    {
      enabled: !!clusterId,
      keepPreviousData: true,
    },
  );
};
